import { useQuery } from '@tanstack/react-query';

import { erpApi } from '@/shared/axios/erp-api';
import { urlBackendSoftnet } from '@/shared/constants';
import { ReporteUsuariosSoftnetResponse } from '../interfaces/reporte-usuarios-softnet.interface';

const { get } = erpApi();

export enum ReporteUsuariosSoftnetQueryKeys {
  REPORTE_USUARIOS_SOFTNET = 'reporte-usuarios',
}

export const getReporteUsuariosSoftnet = () => {
  return get<ReporteUsuariosSoftnetResponse['data']>(
    `${urlBackendSoftnet}/api/reporte-usuarios`,
    true,
  );
};

export const useFetchReporteUsuariosSoftnet = (enabled = true) => {
  return useQuery({
    queryKey: [ReporteUsuariosSoftnetQueryKeys.REPORTE_USUARIOS_SOFTNET],
    queryFn: () => getReporteUsuariosSoftnet(),
    enabled,
    staleTime: 60_000,
  });
};
